import { render, staticRenderFns } from "./GroupForumGroups.vue?vue&type=template&id=047b3f8c&"
import script from "./GroupForumGroups.vue?vue&type=script&lang=js&"
export * from "./GroupForumGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports